module.exports = __webpack_public_path__ + "static/media/01.7c6cfcd7.jpg";